import { render, staticRenderFns } from "./Paste.vue?vue&type=template&id=1a3d9219&scoped=true&"
import script from "./Paste.vue?vue&type=script&lang=js&"
export * from "./Paste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3d9219",
  null
  
)

export default component.exports